import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';

import { LoaderModule } from '@shared/loader/loader.module';
import { DaysPassedPipeModule } from '@shared/pipes/days-passed';
import { HighlightPipeModule } from '@shared/pipes/highlight/highlight.module';

import { CandidateResumeComponent } from './candidate-resume.component';
import { CandidateResumeAchievementsComponent } from './components/candidate-resume-achievements/candidate-resume-achievements.component';
import { CandidateResumeCertificationsComponent } from './components/candidate-resume-certifications/candidate-resume-certifications.component';
import { CandidateResumeEducationComponent } from './components/candidate-resume-education/candidate-resume-education.component';
import { CandidateResumeExperienceComponent } from './components/candidate-resume-experience/candidate-resume-experience.component';
import { CandidateResumeSkillComponent } from './components/candidate-resume-skill/candidate-resume-skill.component';
import { CandidateResumeSkillsComponent } from './components/candidate-resume-skills/candidate-resume-skills.component';

@NgModule({
  declarations: [
    CandidateResumeComponent,
    CandidateResumeSkillsComponent,
    CandidateResumeSkillComponent,
    CandidateResumeExperienceComponent,
    CandidateResumeEducationComponent,
    CandidateResumeCertificationsComponent,
    CandidateResumeAchievementsComponent,
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatExpansionModule,
    DaysPassedPipeModule,
    HighlightPipeModule,
    LoaderModule,
  ],
  exports: [CandidateResumeComponent],
})
export class CandidateResumeModule {}
